export default __webpack_public_path__ + "static/B0048-6147c06cb707036c21e720fc0889c2de.png";